import { render, staticRenderFns } from "./InvoiceCustomerDevicesList.vue?vue&type=template&id=0922ec35"
import script from "./InvoiceCustomerDevicesList.vue?vue&type=script&lang=js"
export * from "./InvoiceCustomerDevicesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports